import { EventBus } from 'relapp-event';
import { formMixin } from 'relapp-way2forms';

let errors = {
    /**
     * Triggers forbidden notification event.
     */
    forbidden() {
        EventBus.$emit('notification', {
            type: 'error',
            message: trans('message.error.forbidden')
        });
    },
    /**
     * Triggers not-found notification event.
     */
    notFound() {
        EventBus.$emit('notification', {
            type: 'error',
            message: trans('message.error.not-found')
        });
    },
    /**
     * Triggers failed validation notification event.
     */
    unprocessableEntity() {
        EventBus.$emit('notification', {
            type: 'warning',
            message: trans('message.error.validation')
        });
    },
    /**
     * Triggers server error notification event.
     */
    serverError() {
        EventBus.$emit('notification', {
            type: 'error',
            message: trans('message.error.general')
        });
    }
};

export default {
    mixins: [formMixin],
    computed: {
        /**
         * Returns the route params.
         *
         * @return {array}
         */
        routeParams() {
            if (!this.domain) {
                return;
            }

            return [
                {
                    key: '{domain}',
                    value: this.domain
                }
            ];
        }
    },
    methods: {
        /**
         * Transforms an object or an array of objects to a class via a model and returns it as an object or an array
         * with objects.
         *
         * @param {(array|object)} data
         * @param {object} Model
         *
         * @return {(array|object)}
         */
        dataToModel(data, Model) {
            if (Array.isArray(data)) {
                return data.map(item => {
                    return new Model(item);
                });
            }

            return new Model(data);
        },
        /**
         * Depending on the response status call a function to handle the response.
         *
         * @param {object} error
         *
         * @return {Promise}
         */
        handleError(error) {
            if (!error || (!error.status && !error.response)) {
                errors.serverError();

                return Promise.reject(error);
            }

            let response = error;

            if (error.response) {
                response = error.response;
            }

            switch (response.status) {
                case 403:
                    errors.forbidden();
                    break;
                case 404:
                    errors.notFound();
                    break;
                case 422:
                    break;
                default:
                    errors.serverError();
            }

            return Promise.reject(error);
        },
        /**
         * Show the validation notification.
         *
         * @param {object} error
         * @param {string} generalNotification
         */
        showValidationNotification(error, generalNotification) {
            let response = error;

            if (error.response) {
                response = error.response;
            }

            if (response.status == 422) {
                if (response.data.errors) {
                    const firstError = Object.values(response.data.errors)[0];

                    EventBus.$emit('notification', {
                        type: 'error',
                        message: firstError[0]
                    });

                    return;
                }

                if (generalNotification) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: generalNotification
                    });
                }
            }

            this.handleError(error);
        },
        /**
         * Show the validation errors in the form.
         *
         * @param {object} error
         * @param {object} form
         */
        showValidationErrors(error, form) {
            form.errors.record(error.data.errors);

            if (error.data) {
                EventBus.$emit('notification', {
                    type: 'error',
                    message: error.data.message
                });
                this.scrollToFirstError();
            } else {
                this.handleError(error);
            }
        },
        /**
         * Show the validation errors in the form.
         *
         * @param {object} error
         * @param {object} form
         */
        showError(error) {
            if (error.data) {
                EventBus.$emit('notification', {
                    type: 'info',
                    message: error.data.message
                });
                this.scrollToFirstError();
            } else {
                this.handleError(error);
            }
        }
    }
};
